import axios from "axios";
import { getTokenMicro } from "./msalService";
import { rotaAutenticação } from "../utils";

const axiosInstance = axios.create({
  baseURL: rotaAutenticação,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await getTokenMicro();
    config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  }, (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance
